import { DateTime } from '@yp/common/time.ts';

export function isUserAdmin(user: { email: string | null }) {
  return user.email === 'brian@mcbarron.net';
}

export function isUserAtParty(user: { email: string | null }) {
  return true;
  if (isUserAdmin(user)) {
    return true;
  }
  const now = DateTime.now();
  return (
    (now.month === 12 && now.day === 31 && now.hour >= 19) || (now.month === 1 && now.day === 1)
  );
}
